var _circle, _circle2, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoader(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 94,
    viewBox: "0 0 94 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 47,
    cy: 47,
    r: 35,
    fill: "#FFD445"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 47,
    cy: 47,
    r: 45,
    stroke: "#363853",
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeDasharray: "4.8 8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_835_2959)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.3818 76.8961C53.218 76.8972 58.9236 75.1676 63.7767 71.9258C68.6299 68.6841 72.4126 64.0759 74.6466 58.6842C76.8806 53.2924 77.4654 47.3592 76.3271 41.635C75.1888 35.9108 72.3785 30.6528 68.2516 26.526C64.1248 22.3991 58.8667 19.5888 53.1425 18.4505C47.4184 17.3122 41.4852 17.897 36.0934 20.1309C30.7016 22.3649 26.0935 26.1477 22.8517 31.0009C19.61 35.854 17.8803 41.5595 17.8815 47.3958C17.8815 51.2698 18.6446 55.1059 20.1271 58.6851C21.6096 62.2642 23.7826 65.5163 26.5219 68.2556C29.2613 70.995 32.5134 73.168 36.0925 74.6505C39.6717 76.133 43.5077 76.8961 47.3818 76.8961Z",
    fill: "#FFC400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.3818 72.1073C52.2719 72.1131 57.0539 70.6683 61.1226 67.9556C65.1913 65.2428 68.364 61.3842 70.2391 56.8678C72.1142 52.3515 72.6076 47.3804 71.6567 42.5836C70.7058 37.7868 68.3534 33.3799 64.8972 29.9204C61.441 26.4609 57.0363 24.1044 52.2404 23.1489C47.4445 22.1935 42.473 22.6821 37.9549 24.5529C33.4367 26.4238 29.5751 29.5928 26.8585 33.6589C24.1419 37.7251 22.6925 42.5057 22.6937 47.3958C22.6952 53.9452 25.296 60.2262 29.9249 64.8595C34.5539 69.4928 40.8324 72.0996 47.3818 72.1073Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.3818 73.2796C42.261 73.2796 37.2553 71.761 32.9976 68.916C28.7399 66.0709 25.4216 62.0272 23.4623 57.2961C21.5029 52.5651 20.9905 47.3592 21.99 42.3369C22.9894 37.3147 25.4557 32.7016 29.0771 29.0811C32.6984 25.4606 37.312 22.9953 42.3345 21.997C47.357 20.9987 52.5627 21.5122 57.2934 23.4727C62.024 25.4331 66.067 28.7524 68.9111 33.0107C71.7552 37.269 73.2726 42.275 73.2714 47.3958C73.2621 54.2588 70.5313 60.8379 65.6779 65.6902C60.8245 70.5425 54.2447 73.2718 47.3818 73.2796ZM47.3818 23.8507C42.725 23.8507 38.1728 25.2316 34.3008 27.8187C30.4288 30.4059 27.411 34.0832 25.6289 38.3855C23.8468 42.6878 23.3806 47.4219 24.2891 51.9892C25.1975 56.5565 27.44 60.7519 30.7328 64.0447C34.0257 67.3375 38.221 69.58 42.7883 70.4885C47.3556 71.397 52.0898 70.9307 56.3921 69.1486C60.6944 67.3666 64.3716 64.3487 66.9588 60.4768C69.546 56.6048 70.9269 52.0526 70.9269 47.3958C70.9191 41.1536 68.436 35.1693 64.0221 30.7554C59.6082 26.3416 53.6239 23.8584 47.3818 23.8507Z",
    fill: "#282D33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.554 25.3453H46.2095V29.9231H48.554V25.3453Z",
    fill: "#282D33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.3624 27.6904L55.0742 31.6552L57.1048 32.8271L59.393 28.8623L57.3624 27.6904Z",
    fill: "#282D33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.8966 35.3872L61.9318 37.6754L63.1037 39.706L67.0685 37.4178L65.8966 35.3872Z",
    fill: "#282D33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.4264 46.2177H64.8486V48.5622H69.4264V46.2177Z",
    fill: "#282D33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.1163 55.1293L61.9436 57.1595L65.9077 59.449L67.0803 57.4188L63.1163 55.1293Z",
    fill: "#282D33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.1298 61.9318L55.0993 63.1041L57.3882 67.0685L59.4186 65.8962L57.1298 61.9318Z",
    fill: "#282D33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.554 64.8568H46.2095V69.4345H48.554V64.8568Z",
    fill: "#282D33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.6524 61.9517L35.3622 65.9153L37.3922 67.0883L39.6824 63.1247L37.6524 61.9517Z",
    fill: "#282D33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6725 55.1288L27.7073 57.4163L28.8788 59.4471L32.8441 57.1596L31.6725 55.1288Z",
    fill: "#282D33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9149 46.2177H25.3372V48.5622H29.9149V46.2177Z",
    fill: "#282D33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.8912 35.3638L27.7185 37.394L31.6826 39.6836L32.8552 37.6534L28.8912 35.3638Z",
    fill: "#282D33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.383 27.7204L35.3522 28.892L37.6396 32.8572L39.6705 31.6856L37.383 27.7204Z",
    fill: "#282D33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.3818 49.9455C46.7963 49.9464 46.2283 49.7463 45.7728 49.3786C45.3172 49.0109 45.0017 48.498 44.879 47.9256C44.7563 47.3532 44.8339 46.756 45.0987 46.2339C45.3635 45.7118 45.7995 45.2964 46.3339 45.0573C46.8682 44.8182 47.4685 44.7697 48.0343 44.9201C48.6 45.0705 49.097 45.4106 49.4421 45.8834C49.7872 46.3563 49.9595 46.9334 49.9301 47.5181C49.9008 48.1027 49.6716 48.6596 49.2808 49.0956C49.0414 49.3622 48.7486 49.5756 48.4215 49.722C48.0944 49.8684 47.7402 49.9445 47.3818 49.9455ZM47.3818 47.1848C47.3527 47.1843 47.3239 47.1904 47.2976 47.2025C47.2712 47.2147 47.2479 47.2327 47.2294 47.2551C47.2106 47.2743 47.1962 47.2973 47.1871 47.3226C47.178 47.3479 47.1744 47.3748 47.1766 47.4016C47.1763 47.4292 47.1819 47.4566 47.193 47.4819C47.2041 47.5072 47.2205 47.5298 47.2411 47.5482C47.2587 47.5702 47.2809 47.5879 47.3063 47.6001C47.3317 47.6123 47.3595 47.6186 47.3876 47.6186C47.4158 47.6186 47.4436 47.6123 47.4689 47.6001C47.4943 47.5879 47.5166 47.5702 47.5342 47.5482C47.5537 47.5291 47.5691 47.5063 47.5797 47.4811C47.5903 47.4559 47.5957 47.4289 47.5957 47.4016C47.5957 47.3743 47.5903 47.3473 47.5797 47.3222C47.5691 47.297 47.5537 47.2742 47.5342 47.2551C47.516 47.2323 47.4927 47.2141 47.4663 47.2019C47.4398 47.1897 47.4109 47.1838 47.3818 47.1848Z",
    fill: "#282D33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.0018 34.8313L47.4144 45.5618L49.1628 47.1239L58.7502 36.3934L57.0018 34.8313Z",
    fill: "#282D33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.1299 37.5392L36.5669 39.2867L46.0123 47.7349L47.5753 45.9873L38.1299 37.5392Z",
    fill: "#282D33"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_835_2959"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 59.0064,
    height: 59.0005,
    fill: "white",
    transform: "translate(17.8815 17.8896)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoader);
export default __webpack_public_path__ + "static/media/Loader.8ee38710c12f68fbe1a08a9a73d880f7.svg";
export { ForwardRef as ReactComponent };